import React from "react";
import { Link } from "react-router-dom";

const LightButton = ({
  icon,
  text,
  to,
  hoverColor = "hover:tw-text-primary",
}) => {
  return (
    <div>
      <Link
        to={to}
        className={`btn-primary text-decoration-none tw-px-2 tw-pe-4 tw-py-2 tw-font-semibold tw-rounded-lg tw-border tw-border-[#837D7D]/50 tw-shadow-[0px_1px_4px_0px_#00000040] tw-flex tw-items-center`}
      >
        {icon}
        <span>{text}</span>
      </Link>
    </div>
  );
};

export default LightButton;
